import './navigation';
import './header';
import './form';
import './consent';
import './documents';
